import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function MarketplaceSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState("polling");
  const [data, setData] = useState(null);
  const attempts = useRef(0);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sid = params.get("session_id");
    if (!sid) {
      navigate("/marketplace");
      return;
    }
    let stopped = false;
    const poll = async () => {
      if (stopped) return;
      if (attempts.current >= 10) {
        setStatus("timeout");
        return;
      }
      attempts.current += 1;
      try {
        const r = await api.get(`/checkout/status/${sid}`);
        setData(r.data);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
        if (r.data.status === "expired") {
          setStatus("expired");
          return;
        }
      } catch (e) {
        console.warn("[MarketplaceSuccess] poll failed", e);
      }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { stopped = true; };
  }, [location, navigate]);

  return (
    <div className="max-w-xl mx-auto py-16">
      <div className="glass-heavy rounded-3xl p-10 text-center grain">
        {status === "polling" && (
          <>
            <Loader2 size={48} className="text-[#00E5FF] animate-spin mx-auto" />
            <h2 className="font-display text-2xl font-bold mt-4">Verifying payment…</h2>
            <p className="text-[#64748B] mt-2 text-sm">Polling Stripe for confirmation.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 size={56} className="text-[#00E5FF] mx-auto" />
            <h2 className="font-display text-3xl font-bold mt-4">Acquired ✦</h2>
            <p className="text-[#64748B] mt-2">
              {data?.metadata?.product_title ? `${data.metadata.product_title} is yours.` : "Transaction confirmed."}
            </p>
            <button data-testid="back-to-market" onClick={() => navigate("/marketplace")} className="mt-6 nexus-btn-primary">Return to Marketplace</button>
          </>
        )}
        {(status === "timeout" || status === "expired") && (
          <>
            <XCircle size={48} className="text-[#F5C542] mx-auto" />
            <h2 className="font-display text-2xl font-bold mt-4">{status === "expired" ? "Session expired" : "Couldn't confirm"}</h2>
            <p className="text-[#64748B] mt-2 text-sm">Try again, or check your email for receipt.</p>
            <button onClick={() => navigate("/marketplace")} className="mt-6 nexus-btn-secondary">Back to Marketplace</button>
          </>
        )}
      </div>
    </div>
  );
}
